/**
 * Stories handled by Zillow Navbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { HEADER_VERSIONS } from '../../../../constants';
import { ZHLLogo } from './components/ZHLLogo';
import { ZillowSearchPageLogo } from './components/ZillowSearchPageLogo';
import { ZillowLogo } from './components/ZillowLogo';

export type ZillowNavbarLogoImageProps = {
    /** Used for determing which logo to show */
    version: HEADER_VERSIONS;
    /** Used for configuring the static asset resolution */
    staticDomain: StaticDomainConfiguration;
    /** Used for determining which logo to show */
    isMobileNavOpen: boolean;
};

/**
 * Dynamically renders the correct zillow logo for the navbar based on the passed in configuration
 */
export const ZillowNavbarLogoImage: FunctionComponent<ZillowNavbarLogoImageProps> = ({
    version,
    staticDomain,
    isMobileNavOpen,
}) => {
    switch (version) {
        case HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY:
        case HEADER_VERSIONS.DEFAULT:
            return <ZillowLogo isMobileNavOpen={isMobileNavOpen} version={version} staticDomain={staticDomain} />;
        case HEADER_VERSIONS.SEARCH_MOBILE_ONLY:
            return (
                <ZillowSearchPageLogo version={version} isMobileNavOpen={isMobileNavOpen} staticDomain={staticDomain} />
            );
        case HEADER_VERSIONS.ZHL_DEFAULT:
            return <ZHLLogo version={version} staticDomain={staticDomain} />;
    }
};
